import { rolesRoutes } from "~/data/rolesRoutes"
export default defineNuxtRouteMiddleware((to) => {
  
  const token = useCookie('rla-token').value

  //Definición de acceso de rutas por roles
  const userData = JSON.parse(localStorage.getItem("rla-auth") || "{}");
  const idRol = userData?.user?.idRol ?? null;
  const rol   = userData?.user?.rol ?? null;

  // Si no hay token y el usuario está en la raíz "/"
  if ((!token || !idRol) && to.path === "/") {
    return navigateTo("/login")
  }
  // Si hay token y el usuario va a login, lo mando a home
  if (token && idRol &&  to.path === "/login") {
    return navigateTo("/")
  }

  const publicRoutes = ["/login", "/reset-password", "/404"] // rutas que no chequea
  if (publicRoutes.includes(to.path)) return
  
  const userStore = useUserStore()

  if (!userStore.user && to.path !== '/login') {
    return navigateTo('/login')
  }


  const roleObj = rolesRoutes.find(r => r.role === rol);
  if (!roleObj || !roleObj.allowedRoutes) return navigateTo("/404")

  const hasAccess = roleObj.allowedRoutes.some(route => {
    if (route === '*') return true              // acceso total
    if (route.endsWith('/*')) {                // rutas dinámicas
      const baseRoute = route.slice(0, -2)     // "/Catalogs/Employee/*" → "/Catalogs/Employee"
      return to.path.startsWith(baseRoute + '/')
    }
    return to.path === route                     // ruta exacta
  })

  if (!hasAccess) return navigateTo('/404')

})
/*
Si se desea seguridad sólo en ciertas páginas, agregar esto al definePageMeta:

<script setup>
definePageMeta({
  middleware: 'auth'
})
</script>

*/